import { render, staticRenderFns } from "./BatchProductBarcodeVerification.vue?vue&type=template&id=180c1a20&"
import script from "./BatchProductBarcodeVerification.vue?vue&type=script&lang=ts&"
export * from "./BatchProductBarcodeVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports